import React from 'react';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function LabelCheckbox({ currencyValue, currency, wager, remained }) {
  const { t } = useTranslation();
  return (
    <Typography>
      {currencyValue} {currency}, {t('Wager')}: x{wager}, {t("there's still some work to be done")}{' '}
      {remained} {currency}
    </Typography>
  );
}
